import { render } from "./PreliminaryFeasibilityTab.vue?vue&type=template&id=6c5bccfc&scoped=true"
import script from "./PreliminaryFeasibilityTab.vue?vue&type=script&lang=js"
export * from "./PreliminaryFeasibilityTab.vue?vue&type=script&lang=js"

import "./PreliminaryFeasibilityTab.vue?vue&type=style&index=0&id=6c5bccfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c5bccfc"]])

export default __exports__